/**
 * Created by zad on 17/11/16.
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { createPortal } from 'react-dom';

export default class Portal extends Component {
  static propTypes = {
    getContainer: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired,
  };

  componentDidMount() {
    this.createContainer();
  }

  componentWillUnmount() {
    this.removeContainer();
  }

  createContainer() {
    this.container = this.props.getContainer();
    this.forceUpdate();
  }

  removeContainer() {
    if (this.container) {
      this.container.parentNode.removeChild(this.container);
    }
  }

  render() {
    if (this.container) {
      return createPortal(this.props.children, this.container);
    }
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/utils/Portal.js